import {getJson} from '../ajax/ajax'
import {OPEN_AMENDMENTS_REACT_PATH} from './../ajax/sdgOnlinePaths';
import {ValidationError, OptimisticLockingError} from "../util/errors";
import SearchUrlUtil from "./SearchUrlUtil";

const handleResponse = (response) => {
  return {data: response.data};
}

const handleError = (error) => {
  // if its a 400 its a validation error, the response payload will be an errors object built by ValidationExceptionToJsonStrategyImpl
  if (error.request) {
    if (error.status === 400) {
      throw new ValidationError(error.data);
    }
    else if (error.status === 409)
    {
      throw new OptimisticLockingError();
    }
  }
  throw error;
};


export default class OpenAmendmentApi {

  static updateResults(tableState) {

    return getJson(OPEN_AMENDMENTS_REACT_PATH + SearchUrlUtil.buildQueryString(tableState)).then(handleResponse, handleError);
  }

}